import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateUserWorkflowAssignments } from 'services/api/AccessManagerAPI';
import { queryKeys } from '../queryKeys';

interface UpdateUserWorkflowAssignmentsArgs {
    id: string;
    workflow_ids: string[];
}

export const useUpdateUserWorkflowAssignments = () => {
    const queryClient = useQueryClient();

    const { mutateAsync: updateUserWorkflowAssignmentsMutation, isPending } = useMutation({
        mutationFn: ({ id, workflow_ids }: UpdateUserWorkflowAssignmentsArgs) =>
            updateUserWorkflowAssignments(id, workflow_ids),
        retry: false,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.accessManager });
        },
    });

    return { updateUserWorkflowAssignments: updateUserWorkflowAssignmentsMutation, isPending };
};
